import { AdminApiRoutes } from '@gr/core/admin-api-routes';
import { ApiRoutes } from '@gr/core/api-routes';
import type { TaskDto, TaskListQuery } from '@gr/core/platform/tasks/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

// TASK-UC-3…6: фоновые задачи блога и всей платформы.
export class TasksApi {
  constructor(private readonly http: HttpClient) {}

  list(blogId: string, query: TaskListQuery = {}): Promise<OperationResult<TaskDto[]>> {
    return this.http.get(ApiRoutes.tasks.list(blogId), { ...query });
  }
  get(blogId: string, taskId: string): Promise<OperationResult<TaskDto>> {
    return this.http.get(ApiRoutes.tasks.byId(blogId, taskId));
  }
  cancel(blogId: string, taskId: string): Promise<OperationResult<TaskDto>> {
    return this.http.post(ApiRoutes.tasks.cancel(blogId, taskId), {});
  }
  resume(blogId: string, taskId: string): Promise<OperationResult<TaskDto>> {
    return this.http.post(ApiRoutes.tasks.resume(blogId, taskId), {});
  }
  listAll(query: TaskListQuery = {}): Promise<OperationResult<TaskDto[]>> {
    return this.http.get(AdminApiRoutes.tasks.list, { ...query });
  }
  cancelAsAdmin(taskId: string): Promise<OperationResult<TaskDto>> {
    return this.http.post(AdminApiRoutes.tasks.cancel(taskId), {});
  }
  resumeAsAdmin(taskId: string): Promise<OperationResult<TaskDto>> {
    return this.http.post(AdminApiRoutes.tasks.resume(taskId), {});
  }
}
